module.exports = __webpack_public_path__ + "static/media/alert-line.3f40b6c6.svg";